var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrochure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: 48,
    height: 48,
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,23.5v-3H32v3Zm0-8v-3H32v3Zm-5,13H27a5.22,5.22,0,0,1,2.45.6,5.94,5.94,0,0,1,1.95,1.6L37,38V7H11ZM11,41H35.5l-6.45-8.45a3,3,0,0,0-.93-.77A2.27,2.27,0,0,0,27,31.5H11Zm26,3H11a2.88,2.88,0,0,1-2.1-.9A2.88,2.88,0,0,1,8,41V7a2.88,2.88,0,0,1,.9-2.1A2.88,2.88,0,0,1,11,4H37a2.88,2.88,0,0,1,2.1.9A2.88,2.88,0,0,1,40,7V41a3.08,3.08,0,0,1-3,3ZM11,41v0Zm0-9.5v0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrochure);
export default __webpack_public_path__ + "static/media/brochure.3124b0fdda8146efe4c482b41e7675a0.svg";
export { ForwardRef as ReactComponent };